<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div
              class="display-2 font-weight-light"
            >{{ id ? "Edit Screen - " + screen.name : "Create Screen" }}</div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="6" md="3">
                  <v-text-field :label="$i18n.t('Name')" v-model="screen.name"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    :disabled="isEdit"
                    :items="types"
                    :label="$i18n.t('Content For')"
                    v-model="screen.kind"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-country-select v-model="screen.country"></z-country-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-checkbox
                    v-if="screen.kind == 1"
                    v-model="screen.hideSearch"
                    :label="$i18n.t('Hide Search')"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" md="3" v-show="isEdit && !isClone">
                  <v-checkbox
                    v-model="screen.isActive"
                    :label="$i18n.t(screen.isActive ? 'Active' : 'Make Active')"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" md="3" v-show="isEdit && !isClone && screen.testUrl">
                  <v-btn :label="$i18n.t('Test It')" :href="screen.testUrl" target="_blank"></v-btn>
                </v-col>

                <v-col cols="6" md="3">
                  <v-text-field
                    :label="$i18n.t('Primary Color')"
                    v-model="screen.primaryColor"
                    type="color"
                  ></v-text-field>
                </v-col>

                <v-col cols="6" md="3">
                  <v-text-field
                    :label="$i18n.t('Secondary Color')"
                    v-model="screen.secondaryColor"
                    type="color"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  <z-language-select v-model="screen.language"></z-language-select>
                </v-col>

                <v-col cols="12" md="3" v-show="isEdit && !isClone">
                  <v-checkbox
                    v-model="screen.isDefault"
                    :label="$i18n.t(screen.isDefault ? 'Default' : 'Make Default')"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn color="info" class="mr-0" v-on:click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-show="screen.kind == 5 && isEdit">
                <h4>{{ $i18n.t("Terms and Conditions") }}</h4>
              </v-row>
              <v-row v-show="screen.kind == 5 && isEdit">
                <v-col cols="12" md="12">
                  <vue-editor v-model="screen.tnc"></vue-editor>
                </v-col>
              </v-row>

              <v-row v-if="screen.kind == 4 && isEdit">
                <h4>{{ $i18n.t("Contact Details") }}</h4>
              </v-row>
              <v-row v-if="screen.kind == 4 && isEdit">
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Phone')" v-model="screen.phone" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Email')" v-model="screen.email"></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  <z-country-select class="purple-input" v-model="screen.office.country"></z-country-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-state-select
                    class="purple-input"
                    v-model="screen.office.state"
                    :country="screen.office.country"
                  ></z-state-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-city-select
                    class="purple-input"
                    v-model="screen.office.city"
                    :state="screen.office.state"
                    :country="screen.office.country"
                  ></z-city-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Address')" v-model="screen.office.addressLine"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('Pincode')"
                    v-model="screen.office.pinCode"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div style="top:-275px; width:50px;position:relative; margin:auto">
                      <v-icon style="font-size: 50px;" color="red">mdi-map-marker</v-icon>
                    </div>
                  </v-row>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  !(
                    screen.kind == 2 ||
                    screen.kind == 3 ||
                    screen.kind == 4 ||
                    screen.kind == 5 ||
                    !isEdit
                  )
                "
              >
                <h4>{{ $i18n.t("Home Content Block") }}</h4>
              </v-row>
              <v-row
                v-if="
                  !(
                    screen.kind == 2 ||
                    screen.kind == 3 ||
                    screen.kind == 4 ||
                    screen.kind == 5 ||
                    !isEdit
                  )
                "
              >
                <v-col cols="12" md="12">
                  <v-text-field
                    :label="$i18n.t('Title')"
                    v-model="screen.homeBlock.title"
                    maxlength="50"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <vue-editor v-model="screen.homeBlock.content" maxlength="3000"></vue-editor>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";
import { VueEditor, Quill } from "vue2-editor";

@Component({
  components: {
    VueEditor,
    Quill,
  },
})
export default class ScreenEdit extends Vue {
  screen = {
    name: "",
    country: "",
    office: { country: "", state: "", city: "", addressLine: "", pinCode: "" },
  };
  message = "";
  file = null;
  id = null;
  isEdit = false;
  isClone = false;
  center = { lat: 45.508, lng: -73.587 };
  markers = [];
  places = [];
  currentPlace = null;
  map = null;

  types = [
    {
      text: "B2C Landing Screen",
      value: 1,
    },
    {
      text: "About Us",
      value: 2,
    },
    {
      text: "Services",
      value: 3,
    },
    {
      text: "Contact Us",
      value: 4,
    },
    {
      text: "Terms and Conditions",
      value: 5,
    },
  ];

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      if (this.screen.kind == 4) {
        this.screen.office.lat = this.map.getCenter().lat();
        this.screen.office.lon = this.map.getCenter().lng();
      }
      this.screen = await doPostForm("/api/screen/save/return", this.screen);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.screen = await doGet("/api/screen/" + id + "/detail");
      this.id = this.screen._id;
      this.isEdit = true;
      if (this.screen.kind == 4) {
        if (this.screen.office == null) {
          this.screen.office = {};
        }
      }
      if (this.screen.kind == 1) {
        this.screen.homeBlock = {};
      }
      if (this.screen.office && this.screen.office.lat) {
        this.center = {
          lat: this.screen.office.lat,
          lng: this.screen.office.lon,
        };
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    await init.getUrlParameter("clone");
    if (init.urlParam) {
      this.isClone = true;
    }
    if (this.screen.kind && this.screen.kind == 4) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
    }
  }

  setPlace(place) {
    this.currentPlace = place;
    this.center = place.geometry.location;
  }

  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }
}
</script>
